import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { UserUpdateInput } from '@libs/types/src/user/input-type/user/user-update.input';
import { InfiniteScrollStore } from '../../../../shared/store/common/infinite-scroll.store';
import { OrganizationGridItemObject } from '@it2go/types';
import { FilterBuilder } from '@libs/shared/utils/grid.builder';

@Injectable()
export class CreateOrganizationPageStore extends ComponentStoreV2Factory {

    public readonly parentOrganizationScroll = computed(() =>
        new InfiniteScrollStore<OrganizationGridItemObject>(
            this.api.getOrganizations,
            new FilterBuilder().sort('name').limit(100).create(),
            true,
            'id name',
        ),
    );

    currentUserId = computed(() =>
        this.globalGlobalStore.loggedUserStore.currentUserId(),
    );

    public async userAssignRulesAndAccess(newOrganizationId: number, userId = this.currentUserId()) {
        if (!userId) return false;

        const { rules, globalRules } = this.getCurrentUserRules();

        if (globalRules.some(r => r.resource === 'organization' && r.action === 'read')) {
            return false;
        }
        const accessRes = await this.api.giveAccess({
            userId: userId,
            organizationId: newOrganizationId,
        });
        if (!accessRes?.ok) return false;

        const data: UserUpdateInput = {
            id: userId,
            organizationId: newOrganizationId,
            rules,
        };
        const user = await this.api.updateUser(data);

        return !!user?.id;
    }

    public getCurrentUserRules() {
        const userRules = this.globalGlobalStore.loggedUserStore.rules();

        const rules: { resource: string; action: string }[] = [];
        const globalRules: { resource: string; action: string }[] = [];

        Object.entries(userRules).forEach(([key, value]: [string, any]) => {
            const [resource, action] = key.split('.');
            const rule = { resource, action };

            if (value.isGlobal) {
                globalRules.push(rule);
            } else {
                rules.push(rule);
            }
        });

        return { rules, globalRules };
    }
}
